<ng-container *ngIf="showBanner">
    <app-banner
      [theme]="bannerConfig.theme"
      [title]="bannerConfig.title"
      [description]="bannerConfig.description"
      [buttonText]="bannerConfig.buttonText"
      [buttonUrl]="bannerConfig.buttonUrl"
      [showCloseButton]="true" 
      (close)="dismissBanner()">
    </app-banner>
</ng-container>

  